import React, { useState, useEffect } from "react";
import { useContext } from "react/cjs/react.development";
import { userContext } from "../../../App";
import NavFront from "./NavFront";
import Search from './Search';
import Sidebar from "./Sidebar";
import SearchFolio from './SearchFolio';
import styled from 'styled-components';
import FooterNew from '../../layouts/FooterNew';
import { db, auth } from "../../../firebase";
import { useHistory } from "react-router";
import ProfileCard from "./ProfileCard";
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import { ParaA } from "../SignIn";
import more from "../../../assets/more.svg";
import Onboardings from "../../layouts/First";
import Grid from '@material-ui/core/Grid';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import Hidden from '@material-ui/core/Hidden';
import CatIcon from '../../../assets/images/Vector.png'

const CategoryList = withStyles((theme) => ({
  root: {
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    // '@media (max-width: 1145px)': {
    //   "margin": "0 20px",
    // },
  }
}))(List);

const CategoryListItemOdd = withStyles((theme) => ({
  root: {
    textDecoration: "none",
    background: "#AFAFAF",
    borderRadius: "0px 100px 100px 0px",
    border: "none",
    width: "137.632px",
    height: "43px",
    marginBottom: "10.725px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "17px",
    lineHeight: "21.425px",
    color: "#FFFFFF",
    cursor: "pointer",
    paddingRight: "14.212px",
    justifyContent: "center",
    '@media (max-width: 950px)': {
      width: "105px",
      fontSize: "15px",
    },
  }
}))(ListItem);
const CategoryListItemEven = withStyles((theme) => ({
  root: {
    textDecoration: "none",
    background: "#AFAFAF",
    borderRadius: "100px 0px 0px 100px",
    border: "none",
    width: "137.632px",
    height: "43px",
    marginBottom: "10.725px",
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "17px",
    lineHeight: "21.425px",
    color: "#FFFFFF",
    cursor: "pointer",
    paddingRight: "14.212px",
    justifyContent: "center",
    '@media (max-width: 950px)': {
      width: "105px",
      fontSize: "15px",
    },
  }
}))(ListItem);

const SearchedResult = (props) => {
  const history = useHistory();
  const [searchtext, setsearchtext] = useState('');
  const [searchtype, setsearchtype] = useState([]);
  const [navClick, setnavClick] = useState(false);
  const [allposts, setallposts] = useState([]);
  const [exacttitle, setexacttitle] = useState('');
  const [searchtitle, setsearchtitle] = useState([]);
  const [searchClicked, setsearchClicked] = useState(false);
  const searcharr = JSON.parse(localStorage.getItem("search"))['search'];
  const category = JSON.parse(localStorage.getItem("search"))['category'];
  const profile = JSON.parse(localStorage.getItem("search"))['profile'];
  const logOut = () => {
    auth.signOut();
    localStorage.removeItem("user");
    history.push("/");
    localStorage.setItem("allowed", "0");
    localStorage.setItem("signup", "0");
  };
  const user = auth.currentUser;
  if (localStorage.getItem('startexperience') === '1') {
    window.scrollTo(0, 0);
    localStorage.removeItem('startexperience');
  }
  let uid = 'empty';
  if (user) {
    uid = user.uid;
    console.log(auth.currentUser.emailVerified, 'emailverify');
  }
  const drawerWidth = 300;

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      fontFamily: "Rubik",
    },
    drawer: {
      marginTop: "500px",
      width: drawerWidth,
      flexShrink: 0,
      fontFamily: "Rubik",
      '@media (max-width: 950px)': {
        width: "230px",
      },
      '@media (max-width: 730px)': {
        width: "0px",
      },
    },
    appBar: {
      // display: "none",
      // visibility: "hidden",
      marginTop: "90px",
      marginLeft: "5px",
      width: "35px",
      height: "35px",
      display: "flex",
      justifyContent: "center",
      right: "0",
      left: "0",
      opacity: "40%",
      boxShadow: "none",
      background: "transparent",
      boxShadow: "none",
      backgroundColor: "transparent",
      // [theme.breakpoints.up('sm')]: {
      //   // display: "block",
      //   // visibility: "show",
      //   width: `calc(100% - ${drawerWidth}px)`,
      //   marginLeft: drawerWidth,
      //   // backgroundColor: "transparent",
      //   boxShadow: "none",
      // },
      '&:hover': {
        opacity: "100%",
        transition: "0.8s",
      },
    },
    menuButton: {
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    drawerPaper: {
      marginTop: "88px",
      paddingBottom: "90px",
      width: drawerWidth,
      fontFamily: 'Rubik',
      // '@media (max-width: 955px)': {
      //   width: `calc(${drawerWidth}px - 50px)`,
      // },
      '@media (max-width: 950px)': {
        width: `calc(${drawerWidth}px - 70px)`,
      },
      '@media (max-width: 730px)': {
        marginTop: "0px",
        paddingTop: "10px",
        paddingBottom: "0px",
        width: `calc(${drawerWidth}px - 30px)`,
      },

    },
    content: {
      marginTop: "85px",
      fontFamily: 'Rubik',
      display: "flex",
      flexDirection: "column",
      width: "100%",
      padding: "24px 24px",
      '@media (max-width: 368px)': {
        padding: "24px 15px 24px 15px",
      },
    },
    link: {
      textDecoration: 'none',
      color: "black",
      cursor: "pointer",
      '&:hover': {
        textDecoration: 'none',
        // color: "black"
      },
      '@media (max-width: 950px)': {
        fontSize: "12.8px",
      },
    },
    footer: {
      margin: "214.5px 0px 30px 0px",
      paddingLeft: "24px",
      fontSize: "13px",
      '@media (max-width: 950px)': {
        paddingLeft: "16px",
        fontSize: "12px",
      },
    },
    copyright: {
      textAlign: "center",
      fontSize: "13px",
      '@media (max-width: 950px)': {
        fontSize: "11px",
      },
    }
  }));


  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  function tileid(x) {
    localStorage.setItem(
      "postid",
      JSON.stringify({
        postid: x,
      })
    );
    history.push(`/folio/${x}`)
  }
  // const [searchtext, setsearchtext] = useState('');
  // const [navClick, setnavClick] = useState(false);
  // const [allposts, setallposts] = useState([]);
  // const [exacttitle, setexacttitle] = useState('');
  // const [searchtitle, setsearchtitle] = useState([]);
  // const [searchClicked, setsearchClicked] = useState(false);
  //let arr = [];
  // db.collection('posts').get().then(
  //     docs =>{
  //         docs.forEach(doc => {
  // if(doc.data().title.toLowerCase().includes(e.target.value.toLowerCase())||doc.data().category.replace(/ /g,"").toLowerCase().includes(e.target.value.replace(/ /g,"").toLowerCase())||doc.data().name.replace(/ /g,"").toLowerCase().includes(e.target.value.replace(/ /g,"").toLowerCase())){
  //     if(doc.data().title===e.target.value ||doc.data().category===e.target.value || doc.data().name===e.target.value){
  //       props.setexacttitle(doc.data());
  //       arr.push({data: doc.data(), id: doc.id});
  //     }
  //     else{
  //       props.setexacttitle('');
  //       arr.push({data: doc.data(), id: doc.id});
  //     }
  //   }
  //     })
  // })
  const drawer = (
    <div>
      <div><h5 style={{ margin: "20px 0 10px 10px" }}>Categories</h5></div>

      <CategoryList>

        <Link to={{ pathname: '/home', category: 'Geography' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Geography</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Physics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Physics</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'History' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>History</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Spiritual' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Spiritual</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Engineering' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Engineering</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Psychology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Psychology</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Economics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Economics</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Parenting' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Parenting</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Chemistry' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Chemistry</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Business' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Business</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Mystery' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Mystery</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Biology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Biology</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Sociology' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Sociology</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Philosophy' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Philosophy</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Commerce' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Commerce</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Maths' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Maths</CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Statistics' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Statistics</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Lifestyle' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Lifestyle </CategoryListItemEven>
        </Link>

        <Link to={{ pathname: '/home', category: 'Theater' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemOdd>Theater</CategoryListItemOdd>
        </Link>

        <Link to={{ pathname: '/home', category: 'Design' }} style={{ textDecoration: 'none' }}>
          <CategoryListItemEven>Design</CategoryListItemEven>
        </Link>

      </CategoryList>

      <div style={{ textAlign: "center", fontSize: "13px" }}>
        <Link to="/all" className={classes.link} style={{ cursor: "pointer" }}>All Categories<ChevronRightRoundedIcon style={{ fontSize: "18px" }} /></Link>
      </div>

      <div className={classes.footer}>
        <Grid container spacing={1} >
          <Grid item xs={6}>
            <Link onClick={() => { logOut() }} className={classes.link} style={{ cursor: "pointer" }}><text>Home</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/about" className={classes.link} style={{ cursor: "pointer" }}><text>About</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/terms" className={classes.link} style={{ cursor: "pointer" }}><text>Terms and Service</text></Link>
          </Grid>

          <Grid item xs={6}>
            <Link to="/faq" className={classes.link} style={{ cursor: "pointer" }}><text>FAQ’s</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/contact" className={classes.link} style={{ cursor: "pointer" }}><text>Contact</text></Link>
          </Grid>
          <Grid item xs={6}>
            <Link to="/privacy" className={classes.link} style={{ cursor: "pointer" }}><text>Privacy Policy</text></Link>
          </Grid>

        </Grid>
      </div>
      <div className={classes.copyright}>
        Copyright &#169;2021 Friend a Book
        <br/>
        Made with 💖 by <a target='_blank' href="https://github.com/Priyanka-Chatterjee-2000">Pri</a>
      </div>
    </div >
  );



  return (
    <React.Fragment>
      {localStorage.getItem('signup') === '1' || localStorage.getItem(uid) === 'firsttime' ? <Onboardings uid={uid} /> : null}
      <div>
        <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle} user={user} searchtext={searchtext} setsearchtext={setsearchtext} setsearchtype={setsearchtype} />
        {!searchClicked && searchtext !== '' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtext={searchtext} searchtype={searchtype} /> : null}

      </div>

      {/* <div style={{ height: "100vh", background: "red" }}>aaaaaaaaa</div>
      <div style={{ height: "100vh", background: "black" }}>bbbbbbbbbb</div>
      <div style={{ height: "100vh", background: "green" }}>ccccccc</div> */}


      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}>

          <img src={CatIcon} alt=""
            style={{ filter: "drop-shadow(10px 10px 12px rgba(0, 0, 0, 0.2))" }}
            className={classes.menuButton}
          />

        </AppBar>
        <nav className={classes.drawer} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              // container={container}
              variant="temporary"
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, //Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>
          {category !== '' ? <Head>{category}</Head> : <Head>Search Results</Head>}
          {profile && profile !== '' ? <ProfileCard name={profile.name} desc={profile.description} follower={profile.follower} profile_pic={profile.profile_pic} profileid={profile.id} /> : null}
          {searcharr.length !== 0 ?
            searcharr.map(each => {
              return (<SearchFolio Image={each.data.img_url} title={each.data.title} name={each.data.name} desc={each.data.description} postedby={each.data.postedBy} id={each.id} onclick={tileid} />)
            }) : null}
        </main>
      </div>
    </React.Fragment>
  )
}

const Head = styled.p`
text-align: left;
font-size: 22px;
// align-self: flex-start;
// width: 730px;
// margin:0;
  @media (max-width: 1115px){
  // width: 600px;
};
  @media (max-width: 950px){
    // width: 450px;
  font-size: 20px;
};
@media (max-width: 500px){
  // width: 320px;
  font-size: 18px;
};
`

const Px = styled(ParaA)`
    margin-top: 4.4vh;
    left: -15.5vw;
    position:relative;
    top: 1.5vh;
    font-weight:400;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 3.2vh;

color: #000000;
`;
const Py = styled(Px)`
    font-size:13px;
    top: 3.6vh;
    text-align:center;
    left: 0vw;
`
const Pz = styled.p`
    position:relative;
    left: 0.95vw;
    right: 0.87vw;
    color:black;
    margin-bottom: 0.76vh;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 2.5vh;
    text-align: left;
   
`
const Categories = styled.div`
    text-align:center;
    position:relative;
    top: 2.74vh;
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    justify-content:space-between;
`;
const Category = styled.button`

    background: #AFAFAF;
    border-radius: 0px 100px 100px 0px;
    border:none;
    width: 9.2vw;
    height: 6vh;
    margin-bottom: 1.5vh;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 3vh;
    color: #FFFFFF;
    cursor: pointer;
    padding-right: 0.95vw;
`;
const CategoryX = styled(Category)`
    border-radius: 100px 0px 0px 100px;
    margin-bottom: 1.5vh;
        padding-right: 0vw;
`
const More = styled.img.attrs(props => ({
  src: more
}))`
    position:absolute;
    margin: 0.76vh 0.36vw 0.76vh 0.36vw
    text-align:center;
`;
const Footer = styled.div`
    position:relative;
      
    //bottom: 7.61vh;
    display:flex;
    flex-direction:row;
    /* align-items:center; */
    /* justify-content:space-between; */
   top:30vh;
    margin: 0.45vh 0.22vw 0.45vh 0.22vw;
`;

const CopyRight = styled(Pz)`

    position: relative;
    font-size:13px;
    top:40vh;
    text-align: center;
    margin-left: -2vw;
    margin-bottom:10px;
`
const Left = styled.div`
    display:flex;
    flex-direction:column;
    text-align:right;
    margin-right: 0.07vw
`
const Right = styled(Left)`
    margin-left: 1.75vw;
`
const Main = styled.div`
/* border:2px solid red; */
    position:relative;
    width: 720px;
   
    /* height: 596px; */
    
    /* top: 188px; */
    margin-bottom: 11.7vh;
`

export default SearchedResult;